/** @jsxImportSource theme-ui */
import * as React from "react";
// DO NOT CHANGE THIS FILE MANUALLY.
// It was generated using iconTemplate.js Please refer to web/src/nessie/icons/README.md for more details
import { nessiePropCheckerWrapper } from "../../nessiePropCheckerWrapper";
import {
  NessieFunctionComponent,
  NessieComponentProps,
  colorNessieResponsivePropType,
  oneOfNessieResponsivePropType,
} from "../../propTypes";
import { NessieThemeColors } from "../../theme";
import UnstyledButton from "../../../../components/buttons/UnstyledButton";
type NotificationIconProps = React.SVGProps<SVGSVGElement> &
  NessieComponentProps & {
    size?: "xs" | "s" | "m" | "l" | "xl" | "xxl";
    color?: NessieThemeColors;
    onClick?: () => void;
    cursor?: React.CSSProperties["cursor"];
    display?: React.CSSProperties["display"];
    "data-test-name"?: string;
    "aria-label"?: string;
  };

let NotificationIcon: NessieFunctionComponent<NotificationIconProps> = ({
  size = "m",
  color = "shale",
  onClick,
  cursor,
  display = "inline-block",
  ["data-test-name"]: dataTestName,
  ["aria-label"]: ariaLabel,
  ...props
}) => {
  const sizeInPixels = SIZES[size];
  const ButtonOrSpan = onClick ? UnstyledButton : "span";
  return (
    <ButtonOrSpan
      aria-label={ariaLabel}
      data-test-name={dataTestName}
      onClick={onClick}
      sx={{
        fontSize: sizeInPixels,
        display,
        lineHeight: 0,
        color,
        cursor,
        position: "relative",
      }}
    >
      {
        <svg
          width="1em"
          height="1em"
          viewBox="0 0 24 24"
          fill="currentColor"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M13.801 20.885H10.2a.244.244 0 00-.249.24C9.95 22.16 10.87 23 12 23s2.05-.84 2.05-1.875a.244.244 0 00-.249-.24zm4.218-5.418c.208-.58.313-1.174.313-1.776V8.82c0-2.485-1.713-4.654-4.282-5.45v-.492C14.05 1.842 13.13 1 12 1s-2.05.842-2.05 1.877v.49c-2.569.798-4.28 2.967-4.28 5.452v4.872c0 .604.104 1.2.312 1.776-1.695.09-2.982.93-2.982 1.987v1.754c0 .133.111.24.249.24h17.503a.245.245 0 00.248-.24v-1.754c0-1.057-1.287-1.897-2.981-1.987z"
          />
          <mask maskUnits="userSpaceOnUse" x={3} y={1} width={18} height={22}>
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M13.801 20.885H10.2a.244.244 0 00-.249.24C9.95 22.16 10.87 23 12 23s2.05-.84 2.05-1.875a.244.244 0 00-.249-.24zm4.218-5.418c.208-.58.313-1.174.313-1.776V8.82c0-2.485-1.713-4.654-4.282-5.45v-.492C14.05 1.842 13.13 1 12 1s-2.05.842-2.05 1.877v.49c-2.569.798-4.28 2.967-4.28 5.452v4.872c0 .604.104 1.2.312 1.776-1.695.09-2.982.93-2.982 1.987v1.754c0 .133.111.24.249.24h17.503a.245.245 0 00.248-.24v-1.754c0-1.057-1.287-1.897-2.981-1.987z"
            />
          </mask>
        </svg>
      }
    </ButtonOrSpan>
  );
};

const SIZES = {
  xs: "12px",
  s: "18px",
  m: "24px",
  l: "36px",
  xl: "48px",
  xxl: "56px",
};
NotificationIcon.nessiePropTypes = {
  color: colorNessieResponsivePropType,
  size: oneOfNessieResponsivePropType(["xs", "s", "m", "l", "xl", "xxl"]),
}; // ------------------------------------------
// ------------------------------------------
// DEV ONLY better prop checking

if (process.env.NODE_ENV === "development") {
  NotificationIcon = nessiePropCheckerWrapper(NotificationIcon);
}

export default NotificationIcon;
